import { placelist1, placelist2, placelist3 } from "resources/placelists";
import Top from "./Top";
import Placelist from "./Placelist";
import Others from "./Others";

const PlacelistDetail3 = () => {
  const placelist = placelist3;
  const otherPlacelists = [placelist1, placelist2];

  return (
    <>
      <Top placelist={placelist} />
      <Placelist placelist={placelist} />
      <Others otherPlacelists={otherPlacelists} />
    </>
  );
};

export default PlacelistDetail3;
